import api from '../token';

export const AddImposto = async (dados) => {
  try {
    const response = await api.post('/addImposto', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};
